import {formatToThousand} from '@Utils/number.util';

export const getCreditUsageText = (creditsCharged: number, remainingCredits: number): string => {
  const remaining = formatToThousand(remainingCredits);
  if (creditsCharged === 1) {
    return window.i18next.t('pmwjs_1_credit_used_with_remaining', {remaining});
  }
  return window.i18next.t('pmwjs_n_credits_used_with_remaining', {
    creditsCount: formatToThousand(creditsCharged),
    remaining,
  });
};
